import { useState } from "react";
import { useTranslation } from "react-i18next"

export function DependentsPage({ setState }: { setState: (arg0: number, arg1: Date) => void }) {
    const { t } = useTranslation(["vennootschapofniet", "common"])

    const [dependents, setDependents] = useState<number>()
    const [dateOfBirth, setDateOfBirth] = useState<Date>()

    const handleDependentsInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDependents(event.target.valueAsNumber)
    }

    const handleDateInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        const eventValue = event.target.valueAsDate
        if (eventValue !== null) {
            setDateOfBirth(eventValue)
        }
    }

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            handleSubmit()
        }
    }

    function handleSubmit() {
        if (dependents !== undefined && dateOfBirth !== undefined) {
            setState(dependents, dateOfBirth)
        }
    }

    return (
        <div>

            <div className=".wrapper-col">
                <h2>{t("dependents__title")}</h2>
                <span className="input">
                    <input autoFocus type="number" id="dependents" name="dependents" onChange={handleDependentsInput} onKeyDown={handleKeyDown}></input>
                    <label htmlFor="dependents">{t("dependents__label")}</label>
                </span>
            </div>

            <br></br>

            <div className=".wrapper-col">
                <h2>{t("dateOfBirth__title")}</h2>
                <span className="input">
                    <input type="date" id="dateOfBirth" name="dependents" onChange={handleDateInput}></input>
                    <label htmlFor="dateOfBirth">{t("dateOfBirth__label")}</label>
                </span>
            </div>

            <button onClick={handleSubmit} className="button-primary">{t("button__next", { ns: "common" })}</button>
        </div>
    )
}